export type SessionState = "idle" | "typing" | "sending" | "ai_generating";

export enum MessageOrder {
  First = "first",
  Last = "last",
  Middle = "middle",
  Sole = "sole",
}

export const SPLIT_MESSAGES_GAP_MINUTE = 30;
